import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const ExpirationCountdown = ({ expiresAt }) => {
  const [timeLeft, setTimeLeft] = useState('');
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date()?.getTime();
      const expiry = new Date(expiresAt)?.getTime();
      const difference = expiry - now;

      if (difference <= 0) {
        setIsExpired(true);
        setTimeLeft('Expired');
        return;
      }

      const hours = Math.floor(difference / (1000 * 60 * 60));
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);

      if (hours > 0) {
        setTimeLeft(`${hours}h ${minutes}m remaining`);
      } else if (minutes > 0) {
        setTimeLeft(`${minutes}m ${seconds}s remaining`);
      } else {
        setTimeLeft(`${seconds}s remaining`);
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [expiresAt]);

  return (
    <div className={`flex items-center justify-center space-x-2 px-4 py-2 rounded-lg ${
      isExpired 
        ? 'bg-error/10 text-error' : timeLeft?.includes('m') && !timeLeft?.includes('h')
          ? 'bg-warning/10 text-warning' :'bg-muted text-muted-foreground'
    }`}>
      <Icon 
        name={isExpired ? "AlertTriangle" : "Clock"} 
        size={16} 
        color={isExpired ? "var(--color-error)" : "currentColor"}
      />
      <span className="text-sm font-medium">
        {isExpired ? 'Preview Expired' : `Link expires in ${timeLeft}`}
      </span>
    </div>
  );
};

export default ExpirationCountdown;